
/**
 * Get the user IP throught the webkitRTCPeerConnection
 * @param onNewIP {Function} listener function to expose the IP locally
 * @return undefined
 */
 var PG_EXCLUDED_FEATURE = ['TEAR_SHEET_REQUEST', 'TEAR_SHEET_DOWNLOAD'];

function getUserIP(onNewIP) { //  onNewIp - your listener function for new IPs
    //compatibility for firefox and chrome
    var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    if(!myPeerConnection){
        return;
    }
    try {
        var pc = new myPeerConnection({
                iceServers: []
            }),
            noop = function () {
            },
            localIPs = {},
            ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
            key;

        function iterateIP(ip) {
            if (!localIPs[ip]) onNewIP(ip);
            localIPs[ip] = true;
        }

        //create a bogus data channel
        pc.createDataChannel("");

        // create offer and set local description
        pc.createOffer().then(function (sdp) {
            sdp.sdp.split('\n').forEach(function (line) {
                if (line.indexOf('candidate') < 0) return;
                line.match(ipRegex).forEach(iterateIP);
            });

            pc.setLocalDescription(sdp, noop, noop);
        }).catch(function (reason) {
            // An error occurred, so handle the failure to connect
        });

        //listen for candidate events
        pc.onicecandidate = function (ice) {
            if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
            ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
        };
    } catch(err){
        console.error(err.message);
    }
}
privateIPOfUser = '';
getUserIP(function(ip){
    privateIPOfUser = ip;
});
function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = jQuery.trim(cookies[i]);
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) == (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
function dummyAjaxRequest(ticker, cut, feature, extras, source, action_source) {
    var url = '/api/loguseraction/';
    var csrftoken = getCookie('csrftoken');
    
    var currentPath = window.location.pathname;
    const postData = {
      feature: feature,
      extras: [{...extras, b_tab: window.b_tab}],
      userIP: [this.privateIPOfUser]
    };

    if(ticker && ticker.length !== 0) {
      postData["company"] = [ticker];
    }

    if(cut && cut.length !== 0) {
      postData["cut"] = [cut];
    }

    if(source && source.length !== 0) {
      postData["source"] = [source];
    }

    if(action_source && action_source.length !== 0) {
      postData["action_source"] = action_source;
    }

    var pgExcludedFeature = PG_EXCLUDED_FEATURE.includes(feature);
    if(window.pg && !pgExcludedFeature && currentPath.includes("/mex/")) {
      postData["pg"] = window.pg;
    }


    $.ajax({
        type: "POST",
        dataType: 'json',
        url: window.apiUrl + url,
        contentType: "application/json",
        data: JSON.stringify(postData),
         headers: { "X-CSRFToken": csrftoken},
        success: function (msg) {
        },
        error: function (msg) {
            console.error(msg.responseText);
        }
    });
}

function callDummyAjaxRequest(event, ticker, cut, feature, extras, source, action_source) {
    // event.originalEvent == undefined means system trigger
    if (!event || (event && (!event.originalEvent && event.isTrigger))) {
        return;
    }

    dummyAjaxRequest(ticker, cut, feature, extras, source, action_source)
}
